import paymentApi from '../../utils/paymentApi';

export async function getCreditUsage(days, signal) {
  const response = await paymentApi.get('/credit-account/usage', { params: { days }, signal });
  const payload = response?.data;
  const data = payload?.data;
  if (Number(payload?.code) !== 200 || !data?.summary || !data?.period
    || String(data.period.days) !== String(days)
    || !Array.isArray(data.by_type) || !Array.isArray(data.recent)) {
    throw new Error('用量暂时无法加载，请稍后重试。');
  }
  return data;
}
